"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EXPORT_PRODUCTS = void 0;
const gql_1 = require("../../../../__generated__/gql");
exports.EXPORT_PRODUCTS = (0, gql_1.gql)(`
  mutation ExportProductPresentationsCsv($input: ExportProductPresentationsCsvInput!) {
    exportProductPresentationsCsv(input: $input) {
      totalRows
      expiresAt
      downloadUrl
      clientMutationId
    }
  }
`);
